import { IReservationEndUser } from 'src/entities/user';
import { IValidationRule, required, emailFormat, phoneFormat, isChecked } from './validations';
import { personalDetailsFields } from './userDetailsRules';

const getReservationEndFields = () => {
    const privacyField: keyof IReservationEndUser = 'PrivacyStatementAccepted';

    return {
        ...personalDetailsFields,
        PrivacyStatementAccepted: privacyField,
        TermsAccepted: 'TermsAccepted'
    }
}

export const reservationEndFields = getReservationEndFields();

export const reservationEndRules = (isEmailRequired: boolean, isPhoneNumberRequired: boolean, isNameRequired: boolean, isTermsRequired: boolean)
    : IValidationRule[] => {
    const rules = [
        emailFormat(reservationEndFields.Email),
        phoneFormat(reservationEndFields.Phone),
        isChecked(reservationEndFields.PrivacyStatementAccepted)
    ];

    if (isEmailRequired) {
        rules.push(required(reservationEndFields.Email));
    }
    if (isPhoneNumberRequired) {
        rules.push(required(reservationEndFields.Phone));
    }
    if (isNameRequired) {
        rules.push(required(reservationEndFields.Name));
    }
    if(isTermsRequired) {
        rules.push(isChecked(reservationEndFields.TermsAccepted));
    }

    return rules;
}


